import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { setCircularLoading } from "../../../reducers/UiReducer";
import { getService } from "../../../reducers/service";
import { serviceNames } from "../../../utils/constants";
import { notify } from "../../../reducers/NotifierReducer";
import { PATH_TRAINING_CERTIFICATIONS } from "../../../utils/routeConstants";
import { mapDictionaryOptions } from "../../../utils/functions";

export const useCertificationData = (id, reset) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const userAgency = useSelector((state) => state.user.userAgency);
	const [loaded, setLoaded] = useState(false);
	const [employees, setEmployees] = useState([]);
	const [certificationTypeOptions, setCertificationTypeOptions] = useState(
		[]
	);
	const dictionary = useSelector((state) => state.dictionary.dictionary);
	const tagTypeOptions = mapDictionaryOptions(dictionary.codePerTagTypes);

	useEffect(() => {
		let isMounted = true;

		const init = async () => {
			try {
				dispatch(setCircularLoading(true));
				setLoaded(false);

				const services = {
					employees: getService(serviceNames.personnel),
					distinctService: getService(
						serviceNames.perTrainingCertificationDistinct
					),
				};

				const results = await Promise.all([
					services.employees.find({
						query: {
							$limit: -1,
							isDeleted: false,
							$sort: { lastName: 1, firstName: 1, middleName: 1 },
							agencyId: userAgency,
						},
					}),
					services.distinctService.find({
						query: {
							column: ["certificationType"],
							agencyId: userAgency,
						},
					}),
				]);

				if (isMounted) {
					setEmployees(results[0]);
					setCertificationTypeOptions(results[1].certificationType);
				}

				if (id) {
					const service = getService(
						serviceNames.perTrainingCertification
					);

					const result = await service.get(id);
					if (isMounted && result) {
						reset({
							id: result.id || null,
							certificationType: result.certificationType || "",
							dateObtained: result.dateObtained
								? moment(result.dateObtained)
										.startOf("day")
										.format("MM/DD/YYYY")
								: "",
							expireDate: result.expireDate
								? moment(result.expireDate)
										.startOf("day")
										.format("MM/DD/YYYY")
								: "",
							certificateNumber: result.certificateNumber || "",
							employee: result.employee || "",
							fromWhom: result.fromWhom || "",
							comments: result.comments || "",
						});
					}
				}
			} catch (error) {
				if (isMounted) {
					dispatch(
						notify(
							"Failed to fetch training certifications",
							"error"
						)
					);
					history.push(PATH_TRAINING_CERTIFICATIONS);
				}
			} finally {
				dispatch(setCircularLoading(false));
				setLoaded(true);
			}
		};

		init();
		return () => {
			isMounted = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id, dispatch, reset, userAgency]);

	return {
		loaded,
		employees,
		certificationTypeOptions,
		tagTypeOptions,
	};
};
